export default __webpack_public_path__ + "static/media/3.bc02a00b.png";